import 'reakit-utils/flatten';
export { warning } from './warning.js';
import 'react';
import 'reakit-utils/isObject';
export { useWarning } from './useWarning.js';
